import { Box, Typography } from '@mui/material'
import CouponImage from '@/src/assets/svgs/CouponImage'

export default function ExclusiveBenefitNote({ note }: { note: string }) {
    return (
        <Box
            sx={{
                backgroundColor: '#E7F6E7',
                borderRadius: 1,
                display: 'flex',
                alignItems: 'center',
                gap: 1,
                p: '0.5rem',
                width : '100%',
            }}
        >
            <CouponImage sx={{ fontSize: '20px' }} />
            <Typography variant="caption" sx={{ color: 'rgb(21, 128, 61)', fontWeight: 'light' }}>
                {note}
            </Typography>
        </Box>
    )
}
